import React from "react";
import bonus from "../../components/bonus.jpeg";

function Bonus() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>**BONUS (Don't Pay For Student Loans)</h1>
          <p>
            <a href="https://drive.google.com/file/d/1gESbMqV0k8Y6LZ7qjrlDSBowky5N2HpD/view?usp=drive_link">
              100+ ways to get rid of your student loans without paying for
              them.
            </a>
          </p>
          <p>Click the link above.</p>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default Bonus;
